import React, { useState } from 'react';
import { simulateUrl, clearSimulatedUrl } from '../utils/devUrlSimulator';

/**
 * 开发工具组件，用于模拟不同域名下的应用
 * 仅在开发环境下显示
 */
const DevTools = () => {
  const [isOpen, setIsOpen] = useState(false);
  
  const handleSimulateUrl = (hostname) => {
    simulateUrl(hostname);
  };
  
  const handleClear = () => {
    clearSimulatedUrl();
  };
  
  // 如果不是开发环境，不渲染任何内容
  if (process.env.NODE_ENV !== 'development') {
    return null;
  }
  
  return (
    <div className="fixed bottom-10 right-2 z-50">
      <button 
        onClick={() => setIsOpen(!isOpen)}
        className="bg-gray-800 text-white p-2 rounded-full shadow-lg text-sm"
      >
        {isOpen ? 'X' : '开发'}
      </button>
      
      {isOpen && (
        <div className="bg-white border border-gray-300 rounded-lg shadow-lg p-3 mt-2 w-48">
          <h3 className="text-sm font-bold mb-2">域名模拟器</h3>
          <div className="space-y-2">
            <button
              onClick={() => handleSimulateUrl('hand.72plus.pro')}
              className="w-full bg-blue-500 text-white py-1 px-2 rounded text-sm hover:bg-blue-600"
            >
              模拟 hand.72plus.pro
            </button>
            <button
              onClick={() => handleSimulateUrl('fupan.72plus.pro')}
              className="w-full bg-green-500 text-white py-1 px-2 rounded text-sm hover:bg-green-600"
            >
              模拟 fupan.72plus.pro
            </button>
            <button
              onClick={handleClear}
              className="w-full bg-red-500 text-white py-1 px-2 rounded text-sm hover:bg-red-600"
            >
              清除模拟
            </button>
          </div>
          <div className="mt-2 text-xs text-gray-500">
            仅用于开发环境测试
          </div>
        </div>
      )}
    </div>
  );
};

export default DevTools; 